export default __webpack_public_path__ + "static/media/dalzel_thumb.e829de0e.jpg";